export class PhoneModel {
    dialingCode: string;
    number: number;
    fullNumber: string;

    constructor(dialingCode?: string, number?: number) {
        this.dialingCode = dialingCode;
        this.number = number;
    }
}